module.exports = __webpack_public_path__ + "static/media/sepulturasPC.fa003023.png";